import React from 'react';
import { AlertTriangle, CheckCircle2 } from 'lucide-react';
interface ScheduleStatusProps {
  isOffSchedule: boolean;
  expectedNextLabel: string | null;
  onPutBackOnSchedule: () => void;
}

// Small line under the next billing date for packs with fixed billing dates
export function ScheduleStatus({
  isOffSchedule,
  expectedNextLabel,
  onPutBackOnSchedule
}: ScheduleStatusProps) {
  if (!isOffSchedule) {
    return <p className="mt-1 flex items-center gap-1 text-[12px] text-[#059669]" data-id="element-5418" data-mp="12szcxa98zfoa">
        <CheckCircle2 className="w-3.5 h-3.5" data-id="element-5419" data-mp="16shlr7nso0ar" />
        On schedule
      </p>;
  }
  return <div className="mt-1" data-id="element-5420" data-mp="1bsm2mysm6x1i">
      <p className="flex items-center gap-1 text-[12px] text-[#D97706]" data-id="element-5421" data-mp="1bray2wrchl9c">
        <AlertTriangle className="w-3.5 h-3.5 flex-shrink-0" data-id="element-5422" data-mp="1gryp3ifkq23k" />
        Off schedule{expectedNextLabel ? ` (pack bills ${expectedNextLabel})` : ''}
      </p>
      <button type="button" onClick={onPutBackOnSchedule} className="mt-0.5 text-[12px] font-medium text-[#0EA5E9] hover:text-[#0284C7] hover:underline" data-id="element-5423" data-mp="2n79c7f1dqxhf">
        Put back on schedule
      </button>
    </div>;
}